var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"persistent":_vm.persistent,"width":"700"}},[_c('h6',{class:_vm.$modals.modalTitle},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }